import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Table, Badge, Row, Col } from 'react-bootstrap';

const formatearMoneda = (monto) => {
    if (monto === null || monto === undefined) return '';
    return `$${monto.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

const formatearFecha = (fechaString) => {
    if (!fechaString) return 'N/A';
    const fecha = new Date(fechaString);
    if (isNaN(fecha.getTime())) return fechaString;
    return fecha.toLocaleDateString('es-MX', { year: 'numeric', month: 'short', day: '2-digit' }).replace(/ /g, '-');
};

const ModalResultadosImportacion = ({ show, handleClose, resultados }) => {
    if (!resultados || resultados.length === 0) return null;

    const importados = resultados.filter(r => r.estatus === 'Importado').length;
    const omitidos = resultados.filter(r => r.estatus !== 'Importado').length;

    const descargarCSV = () => {
        if (!resultados || resultados.length === 0) return;

        const cabeceras = ['Fecha', 'Descripción', 'Monto', 'Estatus'];
        const lineas = resultados.map(r => {
            const fecha = formatearFecha(r.fecha);
            const descripcion = r.descripcion ? `"${r.descripcion.replace(/"/g, '""')}"` : '""';
            const monto = r.monto !== null && r.monto !== undefined ? r.monto : '';
            const estatus = `"${r.estatus}"`;
            return `${fecha},${descripcion},${monto},${estatus}`;
        });

        const csvContent = [cabeceras.join(','), ...lineas].join('\n');
        // Agregar BOM para UTF-8 en Excel
        const blob = new Blob(["\uFEFF" + csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'resultados_importacion.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg" centered backdrop="static">
            <Modal.Header closeButton className="bg-light">
                <Modal.Title className="text-primary fs-0">
                    <i className="fas fa-file-import me-2"></i>
                    Resultados de Importación
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                <div className="bg-light p-3 border-bottom border-200">
                    <Row>
                        <Col xs={6} className="text-center border-end border-200">
                            <h6 className="text-600 mb-1 fs--2 text-uppercase">Importados Exitosamente</h6>
                            <h4 className="text-success mb-0">{importados}</h4>
                        </Col>
                        <Col xs={6} className="text-center">
                            <h6 className="text-600 mb-1 fs--2 text-uppercase">Omitidos (Duplicados)</h6>
                            <h4 className="text-warning mb-0">{omitidos}</h4>
                        </Col>
                    </Row>
                </div>
                <Table responsive hover className="fs--1 mb-0 border-top border-200">
                    <thead className="bg-200 text-800">
                        <tr>
                            <th className="align-middle">Fecha</th>
                            <th className="align-middle">Descripción</th>
                            <th className="align-middle text-end">Monto</th>
                            <th className="align-middle text-center">Estatus</th>
                        </tr>
                    </thead>
                    <tbody>
                        {resultados.map((row, index) => (
                            <tr key={index}>
                                <td className="align-middle fw-semi-bold">{formatearFecha(row.fecha)}</td>
                                <td className="align-middle text-600">{row.descripcion || 'Sin descripción'}</td>
                                <td className="align-middle text-end text-900 fw-bold">{formatearMoneda(row.monto)}</td>
                                <td className="align-middle text-center">
                                    <Badge 
                                        bg={row.estatus === 'Importado' ? 'success' : 'warning'} 
                                        className="fs--2 badge-subtle"
                                    >
                                        {row.estatus}
                                    </Badge>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Modal.Body>
            <Modal.Footer className="bg-light d-flex justify-content-between">
                <Button variant="outline-secondary" size="sm" onClick={descargarCSV}>
                    <i className="fas fa-download me-2"></i>Descargar CSV
                </Button>
                <Button variant="primary" onClick={handleClose}>
                    Aceptar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

ModalResultadosImportacion.propTypes = {
    show: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    resultados: PropTypes.array.isRequired
};

export default ModalResultadosImportacion;
